import { render, staticRenderFns } from "./ClientAgentName.vue?vue&type=template&id=51186858&lang=pug"
import script from "./ClientAgentName.vue?vue&type=script&lang=js"
export * from "./ClientAgentName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,AgentSelect: require('/home/docker/code/frontend/components/AgentSelect.vue').default})
